import React, { useMemo } from 'react';
import classNames from 'classnames';
import styles from './FormControlErrorMessage.scss';
import useTranslation from './Translations/useTranslation';
const FormControlErrorMessage = ({ noMargin = false, errorMessage, className = '', isStatic = false, translateErrorMessage = true, }) => {
    const { t } = useTranslation();
    const message = useMemo(() => {
        if (Array.isArray(errorMessage)) {
            return errorMessage
                .map(m => (translateErrorMessage ? t(m) : m))
                .join(', ');
        }
        if (!translateErrorMessage) {
            return errorMessage;
        }
        return t(errorMessage);
    }, [t, errorMessage, translateErrorMessage]);
    const positionClassNames = useMemo(() => ({
        [styles['message-position-static']]: isStatic,
        [styles['message-position-absolute']]: !isStatic,
    }), [isStatic]);
    return (<small className={classNames(styles.message, positionClassNames, className, {
        'mb-10': !noMargin,
        'no-margin': noMargin,
    })}>
      {message}
    </small>);
};
export default FormControlErrorMessage;
